import React from "react";
import { connect } from "react-redux";

import { getShopItemByID, getShopItemMaxBasketQuantity } from "state/school_money/selectors";
import { setShopItemBasketQuantity, removeShopItemFromBasket } from "state/school_money/actions";

import Currency from "components/Currency";
import RemoveButton from "components/school_money/RemoveButton";
import QuantitySelector from "components/school_money/QuantitySelector";

import "./ShopItem.css";

class ShopItem extends React.Component {
  
  render() {
    
    const { shopItem, price, quantity, maxQuantity } = this.props;
    const name = shopItem.name;
    
    return (
      <div className="shop-item-basket-item">
        <div className="shop-item-basket-item__details">
          <div className="shop-item-basket-item__name">{name}</div>
          <div className="shop-item-basket-item__price">
            <Currency className="shop-item-basket-item__price-amount" amount={price} />
            <RemoveButton className="shop-item-basket-item__remove-button" onClick={this.props.remove} />
          </div>
        </div>
        <div className="shop-item-basket-item__quantity">
          <div className="shop-item-basket-item__quantity-label">Quantity</div>
          <QuantitySelector className="shop-item-basket-item__quantity-selector" quantity={quantity} max={maxQuantity} onChange={this.props.setQuantity} />
        </div>
      </div>
    );
    
  }
  
}

export default connect(
  (state, { studentID, shopItemID }) => ({
    shopItem: getShopItemByID(state, shopItemID),
    maxQuantity: getShopItemMaxBasketQuantity(state, shopItemID)
  }),
  (dispatch, { shopItemID, studentID }) => ({
    setQuantity: quantity => dispatch(setShopItemBasketQuantity(shopItemID, studentID, quantity)),
    remove: () => dispatch(removeShopItemFromBasket(shopItemID, studentID))
  })
)(ShopItem);



// WEBPACK FOOTER //
// ./src/components/school_money/basket/items/shopItem/ShopItem.js